import { useMemo } from 'react';
// routes
import { paths } from 'src/routes/paths';
// locales
import { useLocales } from 'src/locales';
// components
import SvgColor from 'src/components/svg-color';
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

const ICONS = {
  jobs: <SvgColor src="/assets/icons/job/ic_job_details.svg" />,
  talentPool: <Iconify icon="tabler:users-group" />,
  reports: <Iconify icon="tabler:brand-asana" />,
  message: <Iconify icon="tabler:mail" />,
  settings: <Iconify icon="tabler:settings" />,
};

export function useNavData() {
  const { t } = useLocales();

  const data = useMemo(
    () => [
      {
        subheader: t(''),
        items: [
          {
            title: 'Job Listings',
            path: paths.dashboard.jobs.root,
            icon: ICONS.jobs,
          },
          {
            title: 'Talent Pool',
            path: paths.dashboard.candidates.root,
            icon: ICONS.talentPool,
          },
          {
            title: 'Reports',
            path: paths.dashboard.reports,
            icon: ICONS.reports,
          },
          {
            title: 'Automated Email',
            path: paths.dashboard.message.root,
            icon: ICONS.message,
          },
        ],
      },
    ],
    [t],
  );

  return data;
}
